import { render, staticRenderFns } from "./TransferMemberWalletDetails.vue?vue&type=template&id=20fdf91d&"
import script from "./TransferMemberWalletDetails.vue?vue&type=script&lang=js&"
export * from "./TransferMemberWalletDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransferMemberWalletDetails.vue?vue&type=style&index=0&id=20fdf91d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VIcon,VList,VListItem,VRow,VSubheader,VTextField})
